import type { UnionTypeLibelle } from '../../../techniques'
export const ReferenceProjet = ['CertifTtBilan', 'CertifTtAccompagnement', 'ParcoursAlternatifs'] as const
export type ReferenceProjet = (typeof ReferenceProjet)[number]

export const ReferenceProjetLibelle: UnionTypeLibelle<ReferenceProjet> = {
  CertifTtBilan: 'Certif TT - Bilan',
  CertifTtAccompagnement: 'Certif TT - Accompagnement',
  ParcoursAlternatifs: 'Parcours alternatifs',
} as const
